import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { Trans } from 'react-i18next';
import moment from 'moment';
import { BodySemiBold, Header2SemiBold, flexCenter } from '@ubeya/shared-web/components';

const Wrapper = styled.div`
  padding: 16px 0;
  text-align: center;
`;

const DayName = styled(BodySemiBold)`
  ${({ theme, isToday }) => isToday && `color: ${theme.colors.primary};`}
`;

const Day = styled(Header2SemiBold)`
  ${flexCenter};
  margin-top: 12px;
  display: inline-flex;
  border-radius: 50%;
  height: 36px;
  width: 36px;

  ${({ theme, isToday }) =>
    isToday &&
    css`
      background: ${theme.colors.primary};
      color: ${theme.colors.white};
    `}
`;

const HeaderRenderer = ({ date, dayNameOnly = false }) => {
  const isToday = useMemo(() => moment().isSame(date, 'date'), [date]);
  return (
    <Wrapper>
      <DayName isToday={isToday}>
        <Trans>{date.format('ddd').toLowerCase()}</Trans>
      </DayName>
      {!dayNameOnly && <Day isToday={isToday}>{date.format('DD')}</Day>}
    </Wrapper>
  );
};

export default HeaderRenderer;
